import React, { useState } from "react";
import "./loginForm.scss";
import Logo from "../../assets/Logo-mundo-blanco.svg";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CambioPass from "./components/CambioPass";
import CambioCorreo from "./components/CambioCorreo/CambioCorreo";
import { motion, useAnimationControls } from "framer-motion";
import ValidarRut from "./components/ValidarRut/ValidarRut";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

const CambioDatos = ({ setcambioDatos }) => {
  const [rutVerificado, setRutVerificado] = useState(false);
  const [cambioPass, setCambioPass] = useState(true);
  const isMobile = useMediaQuery("(max-width:600px)");
  const control = useAnimationControls();

  const handleSwitch = (e) => {
    setCambioPass(e == "pass");
    control.set({ opacity: 0 });
    control.start({ transition: { duration: 0.4 }, opacity: 1 });
  };

  return (
    <div className="cambioData-container">
      <div className="logo__form">
        <Logo
          className="logo__image__form"
          // src={logo}
          width={"100%"}
          height={"100%"}
        />
      </div>

      <div className="welcome_form">
        <Typography variant="h4" className="titulo__form">
          {!rutVerificado
            ? "Valida tu RUT"
            : `Cambiar ${
                rutVerificado ? "" : cambioPass ? "contraseña" : "correo"
              }`}
        </Typography>
        <Typography variant="h4" className="subtitulo__form">
          Sucursal Virtual
        </Typography>
      </div>
      <div className="login-form">
        <div
          style={{
            marginLeft: "66px",
            marginRight: "66px",
            marginTop: "2.5rem",
            marginBottom: "3rem",
          }}
        >
          <Typography
            variant="h4"
            style={{
              color: "#00657d",
              fontSize: 16,
              textAlign: "center",
              fontFamily: "Montserrat",
              marginBottom: "0.5rem",
            }}
          >
            Cambia tu correo o contraseña
            {!isMobile && <br />}
            utilizando tu número de documento.
          </Typography>

          <ValidarRut
            rutVerificado={rutVerificado}
            setRutVerificado={setRutVerificado}
          />

          {rutVerificado && (
            <>
              <RadioGroup row onClick={(e) => handleSwitch(e.target.value)}>
                <FormControlLabel
                  value="correo"
                  control={
                    <Radio
                      sx={{
                        "&.Mui-checked": {
                          color: "#00AA00",
                        },
                      }}
                    />
                  }
                  label="Cambiar correo"
                />
                <FormControlLabel
                  value="pass"
                  control={
                    <Radio
                      sx={{
                        "&.Mui-checked": {
                          color: "#00AA00",
                        },
                      }}
                    />
                  }
                  checked={cambioPass}
                  label="Cambiar contraseña"
                />
              </RadioGroup>
              <motion.div animate={control}>
                {cambioPass ? <CambioPass /> : <CambioCorreo />}
              </motion.div>
            </>
          )}
        </div>
      </div>
      <div style={{ marginTop: "2rem", marginBottom: "4rem" }}>
        <a
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => {
            setcambioDatos(false);
            setRutVerificado(false);
          }}
        >
          <KeyboardArrowLeftIcon />
          Volver
        </a>
      </div>
    </div>
  );
};

export default CambioDatos;
